import template from './employee_view_performance_management.html';
import * as performance_tutorial_config  from '../tutorial_component/performance_employee_tutorial_config.js';
import * as Utils from '../../lib/savanna_utils.js';
import * as Permissions from '../../lib/permission_utils.js';
import * as PerfManage from '../../lib/performance_management_functions.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewPerformanceManagementViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee = ko.observable();
		this.employee_id = ko.observable();
		this.employee_info = ko.observable({ name: '', code: '', managers: '' });
		this.logged_in_employee = ko.observable();
		this.logged_in_employee(parseInt(localStorage.getItem('employee_id')));
		this.employee_managers = ko.observable();
		this.objective_plans = ko.observableArray();
		this.objectives = ko.observableArray();
		this.selected_plan = ko.observable();
		this.batch_file = ko.observable();
		this.has_attachment = ko.observable(false);
		this.showing_feedback = ko.observable(localStorage.getItem('showing_objective_feedback') || false);
		this.show_peers = ko.observable(localStorage.getItem('show_peers') || false);
		this.measures = ko.observableArray();
		this.rules_progress = ko.observable();
		this.comp_obj_to_add = ko.observableArray();
		this.show_feedback_section = ko.observable(false);
		this.employee_note = ko.observable();
		this.manager_note = ko.observable();
		this.manager_id = ko.observable();
		this.rating_system_options = ko.observableArray();
		this.rating_system_type = ko.observable();
		this.employee_rating = ko.observable();
		this.employee_ratings = ko.observableArray();
		this.manager_ratings = ko.observableArray();
		this.manager_rating = ko.observable();
		this.current_step = ko.observable();
		this.current_step_sequence = ko.observable();
		this.performance_cycles = ko.observableArray(); 
		this.selected_performance_cycle = ko.observable(null); 
		this.is_published = ko.observable(false);
		this.hide_start_review = ko.observable(false);
		this.show_publish_rating = ko.observable(false);
		this.is_manager = ko.observable(false);
		this.peer_rating_feedback = ko.observableArray();
		this.peer_ratings = ko.observableArray();
		this.peer_members = ko.observableArray();
		this.peer_rating = ko.observable();
		this.peer_ratings_multi = ko.observableArray();
		this.peer_note = ko.observable();
		this.rules = ko.observable({
			all_fields_everyone: true,
			all_fields_employee: true,
			name_description: true,
			outcomes_measures: true,
			feedback_manager: true,
			feedback_employee: true,
			peer_feedback: true,
			setup_peer_reviewer: true,
			add_objectives: true,
			linked_company_objectives: false
		});

		  this.objective_status_list = [
        	{ status: 'New' },
        	{ status: 'In Progress' },
        	{ status: 'Obsolete' },
        	{ status: 'On Hold' },
        	{ status: 'Finished' }
    	];

		//tutorial component config
		this.tutorial_config = ko.observable(performance_tutorial_config);
		// Permission observables
		this.hasObjectivesAccess = ko.observable(false);
		this.hasAdminAccess = ko.observable(false);
		this.hasIndividualAccess = ko.observable(false);
		this.has_dashboard_access = ko.observable(false);
		this.is_logged_in = ko.computed(() => {
	    	return this.logged_in_employee() === this.employee_id();
		}, this);

		this.is_manager = ko.computed(() => {
    		const loggedInId = this.logged_in_employee();
    		const managerId = this.manager_id();
			
			return loggedInId && managerId && loggedInId === managerId;
		}, this);


		// Computed permission observables
		this.hasObjectivesOrAdmin = ko.computed(() => {
		    return this.hasObjectivesAccess() || this.hasAdminAccess();
		}, this);

		this.canEditObjective = ko.computed(() => {
		    return this.hasObjectivesOrAdmin() && 
		           (this.rules().name_description || this.rules().outcomes_measures);
		}, this);

		this.canProvideFeedback = ko.computed(() => {
		    return this.hasObjectivesAccess() && this.rules().feedback_employee && this.is_logged_in();
		}, this);

		this.canManageFeedback = ko.computed(() => {
		    return this.rules().feedback_manager && this.is_manager();
		}, this);

		this.canAddObjectives = ko.computed(() => {
		    return this.hasObjectivesOrAdmin() && this.rules().add_objectives;
		}, this);

		this.canStartReview = ko.computed(() => {
		    return this.hasAdminAccess() && this.selected_plan() && 
		           (!this.selected_plan().rating_status || this.selected_plan().rating_status !== 'Started') && 
		           !this.is_published() && !this.hide_start_review();
		}, this);

		this.canPublishRating = ko.computed(() => {
		    return this.hasAdminAccess() && this.show_feedback_section();
		}, this);

		this.canDeletePlan = ko.computed(() => {
		    return this.hasAdminAccess();
		}, this);

		this.can_view_peer_names = ko.computed(() => {
			return this.hasAdminAccess();
		},this)

		this.canEditPlan = ko.computed(() => {
		    return this.hasObjectivesAccess();
		}, this);

		this.canViewEmployeeRating = ko.computed(() => {
		    return this.hasIndividualAccess();
		}, this);

		this.canViewManagerRating = ko.computed(() => {
		    return this.is_published() || this.is_manager();
		}, this);

		this.canViewPeerRating = ko.computed(() => {
		    return this.is_published();
		}, this);

		this.canSaveEmployeeRating = ko.computed(() => {
		    return this.rules().feedback_employee && this.is_logged_in();
		}, this);

		this.canSaveManagerRating = ko.computed(() => {
		    return this.rules().feedback_manager && this.is_manager();
		}, this);

		this.canEditLinkedObjectives = ko.computed(() => {
		    return this.hasObjectivesOrAdmin() && this.rules().linked_company_objectives;
		}, this);

		this.canEditEmployeeFeedback = ko.computed(() => {
		    return this.is_logged_in() && this.rules().feedback_employee;
		}, this);

		this.canEditManagerFeedback = ko.computed(() => {
		    return this.is_manager() && this.rules().feedback_manager;
		}, this);

		this.should_show_start_review_button = ko.computed(() => {
		    return this.selected_plan() && (!this.selected_plan().rating_status || this.selected_plan().rating_status !== 'Started') && !this.is_published() && !this.hide_start_review();
		}, this);

		this.sorted_objectives = ko.computed(() => {
		    return this.objectives().sort((a, b) => a.sequence - b.sequence);
		}, this);

		this.show_peer_names = ko.computed(() => {
    		return this.show_peers() && this.peer_members().length > 0;
		}, this);


		this.selected_plan.subscribe(async(val) => {
			this.employee_note('');
			this.employee_rating('');
			this.employee_ratings([]);
			this.manager_ratings([]);
			this.manager_note('');
			this.manager_rating('');
			this.get_obj_details(val);
			await this.get_current_step_rules();
			this.get_overall_feedback(val);
			console.log('values', val);

			// Show feedback section if rating status is 'Started'
			console.log('values', val)
			if (val && val.rating_status === 'Started')
			{
				this.show_feedback_section(true);
				this.hide_start_review(true);
				this.show_publish_rating(true);
				console.log('show publish rating', this.show_publish_rating())
			}
			else if (val && val.rating_status === 'Finished')
			{
				console.log('rating status finshed')
				this.show_feedback_section(true);
				this.hide_start_review(false);
				this.show_publish_rating(false);
			}
			 else
			{
				this.show_feedback_section(false);
				this.hide_start_review(false);
				this.show_publish_rating(false);
				console.log('show publish rating', this.show_publish_rating())
			}

			setTimeout(() => {
				this.position_mark_as_done_button();
			}, 300)
		});

		// Add a computed observable to determine if we should show the start review button
		this.should_show_start_review_button = ko.computed(() => {
			return this.selected_plan() && (!this.selected_plan().rating_status || this.selected_plan().rating_status !== 'Started') && !this.is_published() && !this.hide_start_review();
		}, this);

		this.selected_performance_cycle.subscribe((val) => { 
			this.updateData();
		});

		// TODO: Do this without jQuery and bootstrap classes in the html (for example without form control and so on)
		$('input[id=batch_file]').change((event) => {
			let file = event.target.files[0]
			if (file)
			{
				$('#upload_input').val(file.name);
				this.has_attachment(true);
			}
			else
			{
				$('#upload_input').val('');
				this.has_attachment(false);
			}
		});

		this.sorted_objectives = ko.computed(() => {
			return this.objectives().sort((a, b) => a.sequence - b.sequence);
		});

		this.showing_feedback.subscribe((val) => {
			localStorage.setItem('showing_objective_feedback', val);
		});

		this.show_peers.subscribe((val) => {
			localStorage.setItem('showing_objective_feedback', val);
		});

		// Initialize permissions
		this.initialize_permissions();

		this.get_employee_info();
	}

	// Initialize permissions method
	async initialize_permissions() {
		try {
			const [objectivesAccess, adminAccess, individualAccess, dashboard_access] = await Promise.all([
				Permissions.checkAccessRights('PerformanceManagementObjectives'),
				Permissions.checkAccessRights('PerformanceManagementAdmin'),
				Permissions.checkAccessRights('PerformanceManagementIndividual'),
				Permissions.checkAccessRights('PerformanceManagementDashboard')
			]);
			
			this.hasObjectivesAccess(objectivesAccess);
			this.hasAdminAccess(adminAccess);
			this.hasIndividualAccess(individualAccess);
			this.has_dashboard_access(dashboard_access);
		} catch (error) {
			console.error('Error checking permissions:', error);
			this.hasObjectivesAccess(false);
			this.hasAdminAccess(false);
			this.hasIndividualAccess(false);
		}

		console.log('hasAdminAcces', this.hasAdminAccess());
	}

	getUpStatus(objective) 
	{
   		const currentStatus = objective.status();
   		const statusFlow = {
   		     'New': 'In Progress',
   		     'In Progress': 'Finished',
   		     'On Hold': 'In Progress',
   		     'Obsolete': null
   		 };
   		 return statusFlow[currentStatus] || null;
	}

	getDownStatus(objective) {
    	const currentStatus = objective.status();
    	const statusFlow = {
    	    'In Progress': 'On Hold',
    	    'Finished': 'In Progress'
    	};
    	return statusFlow[currentStatus] || null;
	}

	async changeStatusUp(objective) {
	    const newStatus = this.getUpStatus(objective);
	    if (newStatus) {
	        await this.updateObjectiveStatusInDB(objective, newStatus);
	    }
	}
	
	async changeStatusDown(objective) {
	    const newStatus = this.getDownStatus(objective);
	    if (newStatus) {
	        await this.updateObjectiveStatusInDB(objective, newStatus);
	    }
	}
	
	async updateObjectiveStatus(objective) {
	    const newStatus = objective.selected_status();
	    if (newStatus && newStatus !== objective.status()) {
	        await this.updateObjectiveStatusInDB(objective, newStatus);
	        objective.toggleStatusUpdate(); // Hide the dropdown after update
	    }
	}
	
	async updateObjectiveStatusInDB(objective, newStatus) {
	    try {
	        let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
	            objective_id: objective.objective_id,
	            objective_status: newStatus
	        });
		
	        if (res.status === 'ERROR') {
	            Grape.alerts.apiError(res);
	        } else if (res.status === 'OK') {
	            objective.status(newStatus); // Update the observable
	            objective.selected_status(newStatus); // Update the selected status
	            Grape.alerts.alert({
	                type: 'success', 
	                message: `Objective status updated to ${newStatus}`
	            });
	        } else {
	            Grape.alerts.alert({
	                type: 'error', 
	                message: 'An error occurred while updating objective status'
	            });
	        }
	    } catch (error) {
	        console.error('Error updating objective status:', error);
	        Grape.alerts.alert({
	            type: 'error', 
	            message: 'An error occurred while updating objective status'
	        });
	    }
	}

	start_review_process()
	{
		this.show_feedback_section(true);
		this.hide_start_review(true);

		let data = {
			objective_plan_id: this.selected_plan().objective_plan_id,
			rating_status : 'Started'
		}

		let res = Grape.fetches.postJSON('/performance_management/start_review_process', data)
		
		if (res)
		{
			Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Successfully started review process'});
		}

	}
	
	position_mark_as_done_button()
	{
		// Ensure this runs after Knockout has updated the DOM
		setTimeout(async () => {
			if (!this.selected_plan() || this.selected_plan().current_step_name === null)
			{
				// Remove button if it exists 
				let existing_button = document.querySelector('.mark-as-done-btn');
				if (existing_button && existing_button.parentNode) {
					existing_button.parentNode.removeChild(existing_button);
				}
				return; 
			}

			// Check permissions using computed observables
			if (!this.hasObjectivesOrAdmin())
			{
				let existing_button = document.querySelector('.mark-as-done-btn');
				if (existing_button && existing_button.parentNode) 
					existing_button.parentNode.removeChild(existing_button);

				return;
			}
		
			// Find the active step in the progress bar
			let active_step = document.querySelector('.progressbar li.active');
			let done_button = document.querySelector('.mark-as-done-btn');
		
			// If the button doesn't exist, create it
			if (!done_button)
			{
				done_button = document.createElement('button');
				done_button.className = 'ps-btn-primary ps-btn mark-as-done-btn';
				done_button.setAttribute('title', 'Mark current step as done, move to next step');
				done_button.innerHTML = '<span class="fa fa-check"></span>&nbsp;<span data-tr="auto" data-tr-section="general">Mark as done</span>';
			
				// Manually add the click handler since Knockout binding won't work on dynamically created element
				done_button.addEventListener('click', () => {
					this.btn_mark_stage_done();
				});
			}
			else
			{
				// Remove button from its current position
				if (done_button.parentNode) 
					done_button.parentNode.removeChild(done_button);
				
			}
		
			if (active_step)
			{
				// Insert button after the active step
				active_step.appendChild(done_button);
			
				done_button.style.cssText = 'display: block !important; visibility: visible !important; margin: 10px 0 !important;';
			}
			else
			{
				let progressbar = document.querySelector('.progressbar');
				if (progressbar && progressbar.parentNode)
				{
					progressbar.parentNode.appendChild(done_button);
					done_button.style.cssText = 'display: block !important; visibility: visible !important; margin: 10px 0 !important;';
				}
			}
		}, 300); // Longer delay
	}

	async get_current_step_rules()
	{
	    if (this.selected_plan())
	    {
	        let rules = await PerfManage.get_current_step_rules(
	            this.selected_plan().performance_cycle_id, 
	            this.selected_plan().current_step, 
	            this.employee_id()  // ← Use employee_id() not selected_plan().employee_id
	        );
	        console.log('Fetched rules for current step:', rules);
		
	        // Make sure rules is valid before setting
	        if (rules) {
	            this.rules(rules);
	        } else {
	            console.error('Rules returned null or undefined');
	            // Set default rules if fetch failed
	            this.rules({
	                all_fields_everyone: false,
	                all_fields_employee: false,
	                name_description: false,
	                outcomes_measures: false,
	                feedback_manager: false,
	                feedback_employee: false,
	                peer_feedback: false,
	                setup_peer_reviewer: false,
	                add_objectives: false,
	                linked_company_objectives: false
	            });
	        }
		
	        let progress = await PerfManage.get_steps_progress(
	            this.selected_plan().performance_cycle_id, 
	            this.selected_plan().current_step, 
	            this.selected_plan().status
	        );
	        this.rules_progress(progress);
		
	        // Wait for DOM to update with the new progress data
	        setTimeout(() => {
	            this.position_mark_as_done_button();
	        }, 300);
	    }
	}

	publish_rating()
	{
		let data = {
			objective_plan_id: this.selected_plan().objective_plan_id,
			is_published : true
		}
		let res = Grape.fetches.postJSON('/performance_management/publish_rating', data)
		
		if (res)
		{
			Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Successfully published ratings and feedback'});
		}

		this.show_publish_rating(false);
	}

	async btn_mark_stage_done() {
		// First, check if we're at the last step
		const isLastStep = this.rules_progress() && Array.isArray(this.rules_progress().steps) && this.selected_plan().current_step >= this.rules_progress().steps.length - 1;

		let confirmMessage = isLastStep ? 
			`Mark "${this.selected_plan().current_step_name}" as done? This is the final step.` : 
			`Mark "${this.selected_plan().current_step_name}" as done?`;

		let response = await Grape.alerts.confirm({ type: 'warning',title: tr('Confirm'), message: confirmMessage });
		
		if (response) {
			// Only increment if not at the last step
			const nextStep = isLastStep ? this.selected_plan().current_step : this.selected_plan().current_step + 1;
			
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/edit', {
				objective_plan_id: this.selected_plan().objective_plan_id,
				current_step: nextStep
			});

			// Rest of the function remains the same
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else if (res.status == 'OK') {
				Grape.alerts.alert({ 
					type: 'success', 
					title: 'Success', 
					message: isLastStep ? 'Final stage completed' : 'Stage/step successfully updated' 
				});

				// Fetch the updated plan data to reflect the new step
				try {
					let updated_plan_res = await Grape.fetches.getJSON('/api/record', {
						table: 'v_objective_plans',
						schema: 'perfm_manage',
						filter: [{
							field: 'objective_plan_id',
							operand: '=',
							value: this.selected_plan().objective_plan_id
						}]
					});

					if (updated_plan_res.status !== 'ERROR' && updated_plan_res.records.length > 0) {
						// Update the plan in the objective_plans array
						let updated_plan = updated_plan_res.records[0];
						let plan_index = this.objective_plans().findIndex(p =>
							p.objective_plan_id === this.selected_plan().objective_plan_id
						);

						if (plan_index !== -1) {
							this.objective_plans.replace(this.objective_plans()[plan_index], updated_plan);
							this.selected_plan(updated_plan);
							await this.get_current_step_rules();
							await this.get_obj_details(updated_plan);
							await this.get_overall_feedback(updated_plan);
							
							setTimeout(() => {
								this.position_mark_as_done_button();
							}, 300);
						}
					}
				} catch (error) {
					console.error('Error refreshing plan data:', error);
					Grape.alerts.alert({ type: 'error', title: 'Error', message: "Error refreshing plan data" });
					await this.updateData();
					await this.get_current_step_rules();
					
					setTimeout(() => {
						this.position_mark_as_done_button();
					}, 300);
				}
			} else
				Grape.alerts.alert({ type: 'error', title: 'Error', message: 'An error occurred while updating current stage/step' });
		}
	}

	async get_employee_info()
	{
		if (this.bindings.employee && ko.isObservable(this.bindings.employee))
		{
			this.bindings.employee.subscribe(async (nv) => {
				if (nv)
				{
					this.employee(nv);
					this.employee_id(nv.employee_id);
					//this.logged_in_employee(parseInt(localStorage.getItem('employee_id')));
					this.updateData();
				}
			});
		}

		if (this.bindings.employee_id && ko.isObservable(this.bindings.employee_id))
			this.bindings.employee_id.subscribe((nv) => { this.employee_id(nv); });
	}

	async btn_add_peers ()
	{
		await Grape.dialog.open('AddPeerMembersObjePlan', { employee_info: this.employee(), objective_plan_id: this.selected_plan().objective_plan_id,});
		this.updateData();

	}

	async btn_delete_plan(data)
	{
		let response = await Grape.alerts.confirm({
			type: 'warning', 
			message: `Are you sure you want to delete ${data.name}?`
		});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/remove', {
				objective_plan_id: data.objective_plan_id
			});
		
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: 'Successfully deleted'});
		        // Remove the plan from the observable array
				this.objective_plans.remove(data);
		        // Clear selected plan if it was the deleted one
				this.selected_plan(null);
			}
			else
				Grape.alerts.alert({type: 'error', message: 'An error occurred while deleting the Objective Plan'});
		}

	}

	async btn_save_overall_note()
	{
		let note;
		let rating;
		if (this.is_manager())
		{
			note = this.manager_note();
			if (this.rating_system_type() === 'multiselect')
				rating = this.manager_ratings().toString();
			else
				rating = this.manager_rating().toString();
		}
		else
		{
			note = this.employee_note();
			if (this.rating_system_type() === 'multiselect')
				rating = this.employee_ratings().toString();
			else
				rating = this.employee_rating().toString();
		}

		console.log('rating', rating);

		if (!rating || rating === 'NaN')
		{
		    Grape.alerts.alert({
		        type: 'warning',
		        title: 'Warning',
		        message: tr('No rating was selected. Please select a rating to save your feedback.')
		    });
		    return;
		}

		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Update Feedback') , message: 'Update overall feedback?'});
		if (response)
		{
			let res = await Grape.fetches.postJSON('performance_management/objective_plan_feedback/edit', {
				objective_plan_id: this.selected_plan().objective_plan_id,
				employee_id: this.logged_in_employee(),
				notes: note,
				rating: rating,
				rating_system_id: this.selected_plan().rating_system_id 
			});

			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: window.tr('Successfully updated your feedback.')});
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while updating feedback.')});
		}
	}

	async btn_add_objetive_plan(data)
	{
		await Grape.dialog.open('AddObjectivePlan', { employee_info: this.employee(), edit: false});
		this.updateData();
	}

	async btn_edit_objective_plan(data) {
		let res = await Grape.dialog.open('AddObjectivePlan', { 
			employee_info: this.employee(), 
			data: data, 
			edit: true 
		});
		
		// After editing, fetch the updated plan data
		try
		{
			let updated_plan_res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_objective_plans',
				schema: 'perfm_manage',
				filter: [{
					field: 'objective_plan_id',
					operand: '=',
					value: data.objective_plan_id
				}]
			});

			if (updated_plan_res.status !== 'ERROR' && updated_plan_res.records.length > 0) {
				// Update the plan in the objective_plans array
				let updated_plan = updated_plan_res.records[0];
				let plan_index = this.objective_plans().findIndex(p => 
					p.objective_plan_id === data.objective_plan_id
				);
				
				if (plan_index !== -1)
				{
					// Update in the array
					this.objective_plans.replace(this.objective_plans()[plan_index], updated_plan);
					
					// If this was the selected plan, update the selected plan
					if (this.selected_plan() && this.selected_plan().objective_plan_id === data.objective_plan_id) 
						this.selected_plan(updated_plan);
				}
			}
			this.updateData();
		}
		catch (error)
		{
			console.error('Error refreshing plan data:', error);
			Grape.alerts.alert({
				type: 'error', message: window.tr('Error refreshing plan data')
			});
		}
		
		this.updateData();
	}

	async btn_edit_an_objective(data)
	{
		if (data.editing())
		{
			let response = await Grape.alerts.confirm({type: 'warning', title: 'Confirm', message: 'Are you sure want to save changes to this objective?'});
			if (response)
			{
				try {
					let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
						objective_id: data.objective_id,
						name: data.name,
						description: data.description,
						expected_result: data.expected_result,
						measure: data.measure
					});
					if (res.status == 'ERROR')
						Grape.alerts.apiError(res);
					else if (res.status == 'OK')
						this.get_obj_details(data.objective_plan_id);
					else
						Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while attempting to save changes to this objective. We apologise for the inconvenience...')});
				} catch (error) {
					console.error(error);
					Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while attempting to save changes to this objective. We apologise for the inconvenience...')});
				}
			}
		}
		else
			data.editing(!data.editing());
	}

	async btn_edit_emp_feedback(data)
	{
		if (data.editing_emp_feedback())
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/edit', {
				objective_id: data.objective_id,
				employee_id: data.employee_id,
				feedback: data.employee_feedback
			});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: window.tr('Successfully updated your feedback.')});
				this.get_obj_details(this.selected_plan());
				data.editing_emp_feedback(!data.editing_emp_feedback());
			}
			else
				Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while updating feedback.')});
		}
		else
			data.editing_emp_feedback(!data.editing_emp_feedback());
	}

	async btn_edit_manager_feedback(data)
	{
		if (data.editing_manager_feedback())
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/edit', {
				objective_id: data.objective_id,
				employee_id: Utils.current_employee_id(),
				feedback: data.manager_feedback
			});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: window.tr('Successfully updated your feedback.')});
				this.get_obj_details(this.selected_plan());
				data.editing_manager_feedback(!data.editing_manager_feedback());
			}
			else
				Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while updated feedback.')});
		}
		else
			data.editing_manager_feedback(!data.editing_manager_feedback());
	}

	async btn_cancel_delete_feedback(data)
	{
		if (data.editing_emp_feedback())
			data.editing_emp_feedback(!data.editing_emp_feedback());
		else if (data.editing_manager_feedback())
			data.editing_manager_feedback(!data.editing_manager_feedback());
		else if (!data.editing_emp_feedback() && !data.editing_manager_feedback())
		{
			let response = await Grape.alerts.confirm({ type: 'warning', message: window.tr('Are you sure you want to remove this feedback?')});
			if (response)
			{
				let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/remove', { 
					objective_feedback_id: data.objective_feedback_id,
					employee_id: Utils.current_employee_id(),
					feedback: ''
				});
				if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
				{
					Grape.alerts.alert({type: 'Success', message: tr('Successfully removed feedback')});
					this.get_obj_details(data.objective_plan_id);
				}
			}
		}
	}

	async btn_cancel_remove_objective(data)
	{
		if (data.editing())
			data.editing(!data.editing());
		else
		{
			let response = await Grape.alerts.confirm({ type: 'warning', message: tr('Are you sure you want to remove this objective?')});
			if (response)
			{
				let res = await Grape.fetches.postJSON('/performance_management/objective/remove_from_plan', { objective_id: data.objective_id });
				if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
				{
					Grape.alerts.alert({type: 'Success', message: tr('Successfully removed objective')});
					this.get_obj_details(data.objective_plan_id);
				}
			}
		}
	}

	async move_order_up(data)
	{
		let sequence;
		if (data.sequence > 1)
			sequence = parseInt(data.sequence) - 1;
		else
			sequence = data.sequence;
		try {
			let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
				objective_id: data.objective_id,
				sequence: sequence
			});
			if (res.status != 'ERROR')
				this.get_obj_details(data);
		} catch (error) {
			console.error(error);
		}
	}

	async move_order_down(data)
	{
		let sequence = parseInt(data.sequence) + 1;
		try {
			let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
				objective_id: data.objective_id,
				sequence: sequence
			});
			if (res.status != 'ERROR')
				this.get_obj_details(data);
		} catch (error) {
			console.error(error);
		}
	}

	show_help()
	{
		Grape.dialog.open('PerformanceObjectivesSummaryHelp', {});
	}

	show_details_help()
	{
		Grape.dialog.open('PerformanceObjectiveDetailsHelp', {});
	}

	async btn_add_objective_to_plan()
	{
		await Grape.dialog.open('AddToObjectivePlan', { employee_info: this.employee(), data: this.selected_plan()});
		this.get_obj_details(this.selected_plan());
	}

	select_objective_plan_click(data)
	{
		this.selected_plan(data);
		this.rating_system_type(data.rating_method_type);
		this.updateData();
		// Reposition button when a new plan is selected
		setTimeout(() => {
			this.position_mark_as_done_button();
		}, 300);
	}


	async updateData()
	{
		await Utils.refresh_data_visible_roles();	
		if (!this.employee_id()) {
			console.log('No employee ID available, skipping objective plans fetch');
			return; // Exit the method if no employee_id is available
		}
		
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'measure',
				schema: 'perfm_manage'
			})

			if (res.status != 'ERROR')
				this.measures(res.records);
		} catch (error) {
			console.error(error);
		}
		
		try {
			if (this.employee())
			{
				let data_query = {
					table: 'v_objective_plans',
					schema: 'perfm_manage',
					filter: [{
						field: 'employee_id',
						operand: '=',
						value: this.employee_id()
					}]
				}

				if (this.selected_performance_cycle())
					data_query.filter.push({ field: 'cycle_name', operand: '=', value: this.selected_performance_cycle() }); 
				
				let res = await Grape.fetches.getJSON('/api/record', data_query);

				if (res.status != 'ERROR') 
				{
					this.objective_plans(res.records);
					if (!this.selected_performance_cycle()) {
						let uniqueCycleNames = [...new Set(res.records.map(record => record.cycle_name))];

						this.performance_cycles(uniqueCycleNames);
					}
				}				
			}
		}
		catch (error)
		{
			console.error(error);
		}

		try {
			if (this.employee())
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_employee_profile',
					schema: 'savanna',
					filter: [{
						field: 'employee_id',
						operand: '=',
						value: this.employee_id()
					}]
				});
	
				if (res.status != 'ERROR')
				{
					if (res.records[0].employee_managers)
					{
						this.employee_info({
							name: this.employee().firstname + ' ' + this.employee().surname || '',
							code: this.employee().employment_info[0].employee_code || ' ',
							managers: res.records[0].employee_managers[0].fullnames || ' ',
							manager_ids: res.records[0].employee_managers[0].employee_id
						});
					}
					else
						this.employee_info({
							name: this.employee().firstname + ' ' + this.employee().surname || '',
							code: this.employee().employment_info[0].employee_code || ' ',
							managers: 'none',
							manager_ids: null
						});
				}
			}
		} catch (error) {
			console.error(error);
		}

		await Utils.refresh_data_visible_roles();	

		this.employee_managers(this.employee_info().managers);
		this.manager_id(parseInt(this.employee_info().manager_ids));
		console.log('manager ID' , this.manager_id());
		
		this.get_obj_details(this.selected_plan());
		this.get_current_step_rules();
		this.get_overall_feedback(this.selected_plan());

		await Utils.refresh_data_visible_roles();	

		setTimeout(() => {
			this.position_mark_as_done_button();
		}, 300);

	};

	async get_overall_feedback(data) {
		this.is_published(false);
		//get rating system options:
		try {
			if (this.selected_plan()) {
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'rating_system_option',
					schema: 'perfm_manage',
					filter: [{
						field: 'rating_system_id',
						operand: '=',
						value: this.selected_plan().rating_system_id
					}]
				});
				if (res.status != 'ERROR')
					this.rating_system_options(res.records);
			}
			else
				return;
	
		} catch (error) {
			console.error(error);
		}
	
		try {
			if (this.selected_plan()) {
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'emp_manager_rating',
					schema: 'perfm_manage',
					filter: [{
						field: 'objective_plan_id',
						operand: '=',
						value: this.selected_plan().objective_plan_id
					}]
				});

				console.log('res', res);
				if (res.status != 'ERROR') {
					// Check if records array exists and has at least one element
					if (res.records && res.records.length > 0) {
						if (res.records[0].is_published)
							this.is_published(true);
						
						console.log('is it published', this.is_published());
						res.records.forEach(record => {
							if (record.employee_id === this.employee_id()) {
								this.employee_note(record.notes || '');
								if (this.rating_system_type() === 'multiselect') {
									let rating_array = record.rating ? record.rating.split(',').map(item => parseInt(item.trim(), 10)) : [];
									this.employee_ratings(rating_array);
								}
								else if (this.rating_system_type() === 'single-select') {
									let rating = parseInt(record.rating);
									this.employee_rating(rating);
								}
								else
									this.employee_rating(record.rating);
							}
							else if (record.employee_id === this.manager_id()) {
								this.manager_note(record.notes || '');
								if (this.rating_system_type() === 'multiselect') {
									let rating_array = record.rating ? record.rating.split(',').map(item => parseInt(item.trim(), 10)) : [];
									this.manager_ratings(rating_array);
								}
								else if (this.rating_system_type() === 'single-select') {
									let rating = parseInt(record.rating);
									this.manager_rating(rating);
								}
								else
									this.manager_rating(record.rating);
							}
						});
					} else {
						// Handle the case when there are no records
						console.log('No records found for the selected plan');
						this.is_published(false); // Set default value when no records exist
					}
				}
				 let peer_rating_req = {
                table: 'v_peer_rating',  // Using the view that includes firstname_of_peer and surname_of_peer
                schema: 'perfm_manage',
                filter: [{
                    field: 'objective_plan_id',
                    operand: '=',
                    value: this.selected_plan().objective_plan_id
                }]
            };
        
            let peer_rating_res = await Grape.fetches.getJSON('/api/record', peer_rating_req);
            console.log('peer_rating_result', peer_rating_res);
        
            if (peer_rating_res.status != 'ERROR') {
                if (peer_rating_res.records && peer_rating_res.records.length > 0) {
                    // Set published status from first record
                    if (peer_rating_res.records[0].is_published) {
                        this.is_published(true);
                    }

                   let peersMap = new Map();

peer_rating_res.records.forEach(record => {
    // Create a unique identifier for each peer
    let peerKey = `peer_${record.peer_member_id}`;
    let peerName = `${record.firstname_of_peer || ''} ${record.surname_of_peer || ''}`.trim();
    
    console.log('Processing peer record:', record); // Debug log
    
    // Process rating based on rating system type
    let processedRating = null;
    let processedRatings = [];
    
    if (record.rating) {
        if (this.rating_system_type() === 'multiselect') {
            processedRatings = record.rating.toString().split(',').map(r => parseInt(r.trim()));
        } else if (this.rating_system_type() === 'single-select' || this.rating_system_type() === 'number') {
            processedRating = parseInt(record.rating);
        } else {
            processedRating = record.rating;
        }
    }
    
    // Store peer data in the map with proper observables
    peersMap.set(peerKey, {
        peer_name: peerName,
        firstname_of_peer: record.firstname_of_peer || '',
        surname_of_peer: record.surname_of_peer || '',
        rating: record.rating || '',
        notes: record.notes || '',
        peer_member_id: record.peer_member_id,
        peer_rating_id: record.peer_rating_id,
        // Create observables with the processed values
        peer_rating_observable: ko.observable(processedRating),
        peer_ratings_observable: ko.observable(processedRatings)
    });
});

// Convert Map to Array and set peer_members
let peersArray = Array.from(peersMap.values());
this.peer_members(peersArray);

console.log('Current objective_plan_id:', this.selected_plan().objective_plan_id);
console.log('Processed peers:', peersArray);
console.log('Rating system type:', this.rating_system_type());
                    
                    // Set single peer rating/note observables for the first peer (for backward compatibility)
                    if (peersArray.length > 0) {
                        let firstPeer = peersArray[0];
                        this.peer_note(firstPeer.notes);
                        
                        if (this.rating_system_type() === 'multiselect') {
                            let rating_array = firstPeer.rating ? firstPeer.rating.split(',').map(item => parseInt(item.trim(), 10)) : [];
                            this.peer_ratings(rating_array);
                        } else if (this.rating_system_type() === 'single-select') {
                            let rating = firstPeer.rating ? parseInt(firstPeer.rating) : 0;
                            this.peer_rating(rating);
                        } else {
                            this.peer_rating(firstPeer.rating);
                        }
                    }
                } else {
                    // No peer rating records found
                    this.peer_members([]);
                    console.log('No peer rating records found');
                }
            }
        } else {
            return;
        }
    } catch (error) {
        console.error('Error fetching peer ratings:', error);
        this.peer_members([]);
    }
}


	// Helper method to format rating display
	formatRatingDisplay(rating) {
	    if (!rating) return '';
	
	    // Find the matching rating option
	    let ratingOption = this.rating_system_options().find(option => 
	        option.rating_system_option_id == rating
	    );
	
	    if (ratingOption) {
	        return ratingOption.symbol ? `${ratingOption.symbol} - ${ratingOption.name}` : ratingOption.name;
	    }
	
	    return rating; // Fallback to raw rating value
	}

	async get_obj_details(data) {
    if (data) {
        let objective_plan_id = parseInt(data.objective_plan_id) || this.selected_plan().objective_plan_id;
        let res = await Grape.fetches.getJSON('/api/record', {
            table: 'v_objectives_for_objective_plan',
            schema: 'perfm_manage',
            sort_order: 'ASC',
            sort_field: 'sequence',
            filter: [{
                field: 'objective_plan_id',
                operand: '=',
                value: objective_plan_id
            }]
        });
        
        if (res.status != 'ERROR') {
            let items = res.records.map((x) => ({
                ...x,
                editing: ko.observable(false),
                editing_emp_feedback: ko.observable(false),
                editing_manager_feedback: ko.observable(false),
                // Initialize status observables properly
                status: ko.observable(x.status || 'New'),
                selected_status: ko.observable(x.status || 'New'),
                status_update_visible: ko.observable(false),
                
                // Toggle function for status update visibility
                toggleStatusUpdate: function() {
                    this.status_update_visible(!this.status_update_visible());
                    if (this.status_update_visible()) {
                        this.selected_status(this.status());
                    }
                },
                
                linked_company_objectives: ko.observable((x.linked_company_objectives || []).map((x) => ({
                    ...x,
                    display_name: x.number + ' ' + x.description
                })))
            }));
            this.objectives(items);
        }
    }
}

	viewStatusHelp() {
    Grape.alerts.alert({
        type: 'warning',
        title: 'Objective Status Definitions',
        message: `
            <strong>New:</strong> Objective has been created but work hasn't started<br>
            <strong>In Progress:</strong> Work on the objective is currently underway<br>
            <strong>On Hold:</strong> Work has been temporarily paused<br>
            <strong>Obsolete:</strong> Objective is no longer relevant or needed<br>
            <strong>Finished:</strong> Objective has been completed successfully
        `
    });
}



	async btn_view_plan(data)
	{
		let progress = await PerfManage.get_steps_progress(data.performance_cycle_id, data.current_step, data.status);
		Grape.dialog.open('ViewPerfObjectivePlan', {data: data, employee_info: this.employee_info(), progress: progress, manager_id: this.manager_id(), employee_id: this.employee_id() });
	}

	async btn_edit_linked_comp_objectives(data)
	{
		let res = await Grape.dialog.open('LinkCompanyObjectives', { data: data, to_add: null, to_remove: null, editing: true, linked_comp_objectives: data.linked_company_objectives() || []});
		this.get_obj_details(this.selected_plan());
	}
}

export default {
	name: 'employee_view_performance_management',
	viewModel: EmployeeViewPerformanceManagementViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_performance_management'
};
